// extracted by mini-css-extract-plugin
export default {"input-box":"InputApprovers_input-box__+Uk5y","label":"InputApprovers_label__o1wuM","input":"InputApprovers_input__q3Fy+"};